// eslint-disable-next-line no-unused-vars
let timer, flag;
import axios from "axios";

//  字符串 转 base64
export function xBase64Encode(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

// base64 转 字符串
export function xBase64Decode(base64) {
  return decodeURIComponent(escape(atob(base64)));
}

/**
 * 获取日期
 * @param {any} timestamp - 日期: 日期字符串/时间戳/不传(不传时获取当前日期时间)
 * @param {string} format - 日期时间格式
 * @returns {string} 返回日期时间的字符串格式，默认格式为YYYY-MM-DD HH:mm:ss。
 */
export function getCurrentDateTime(timestamp, format = "YYYY-MM-DD HH:mm:ss") {
  let time;
  if (timestamp instanceof Date && !isNaN(timestamp.getTime())) {
    time = timestamp;
  } else if (timestamp) {
    if (typeof timestamp === "string" && /^\d+$/.test(timestamp)) timestamp = parseInt(timestamp);
    time = new Date(timestamp);
    if (isNaN(time.getTime())) throw new Error(`timestamp is not a time => ${timestamp}`);
  } else {
    time = new Date();
  }
  const year = time.getFullYear();
  const month = String(time.getMonth() + 1).padStart(2, "0");
  const day = String(time.getDate()).padStart(2, "0");
  const hours = String(time.getHours()).padStart(2, "0");
  const minutes = String(time.getMinutes()).padStart(2, "0");
  const seconds = String(time.getSeconds()).padStart(2, "0");
  const milliseconds = String(time.getMilliseconds()).padStart(3, "0");
  const formatMap = {
    "YYYY-MM-DD HH:mm:ss": `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`,
    YYYYMMDDHHmmss: `${year}${month}${day}${hours}${minutes}${seconds}`,
    "YYYY-MM-DD HH:mm": `${year}-${month}-${day} ${hours}:${minutes}`,
    "YYYY-MM-DD HH": `${year}-${month}-${day} ${hours}`,
    "YYYY-MM-DD": `${year}-${month}-${day}`,
    YYYYMMDD: `${year}${month}${day}`,
    "YYYY-MM": `${year}-${month}`,
    YYYYMM: `${year}${month}`,
    "MM-DD": `${month}-${day}`,
    MMDD: `${month}${day}`,
    "HH:mm": `${hours}:${minutes}`,
    HHmm: `${hours}${minutes}`,
    "mm:ss": `${minutes}:${seconds}`,
    mmss: `${minutes}${seconds}`,
    YYYY: year,
    MM: month,
    DD: day,
    HH: hours,
    mm: minutes,
    ss: seconds,
    "YYYY-MM-DDTHH:mm:ss": `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`,
    "YYYY-MM-DDTHH:mm:ssZ": `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`,
    "YYYY-MM-DDTHH:mm:ss.SSS": `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`,
    "YYYY-MM-DDTHH:mm:ss.SSSZ": `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`,
    "YYYY-MM-DDTHH:mm:ss.SSS[Z]": `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`,
    "YYYY-MM-DDTHH:mm:ss[Z]": `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`,
    "YYYY-MM-DDTHH:mm:ss[+08:00]": `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+08:00`,
    "YYYY-MM-DDTHH:mm:ss[+0800]": `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+0800`,
    parse: Date.parse(time),
  };
  return formatMap[format];
}

export function wxConfig() {
  // .post(window.xheader + "/api/Invoice/GetWxConfig", { url: "http://invoice.yuehego.com" })
  // .post(window.xheader + "/api/Invoice/GetWxConfig", { url: encodeURIComponent(window.location.href) })
  // .post(window.xheader + "/api/Invoice/GetWxConfig", { url: encodeURIComponent(window.location.href.split("#")[0]) })
  axios
    .post(window.xheader + "/api/Invoice/GetWxConfig", { url: window.location.href.split("#")[0] })
    .then((data) => {
      window.access_token = data.access_token;
      window.wx.config({
        debug: false,
        appId: data.appid,
        timestamp: data.timestamp,
        nonceStr: data.noncestr,
        signature: data.signature,
        jsApiList: ["chooseInvoiceTitle"],
      });
      window.wx.ready(() => {
        // console.log('微信功能正常');
      });
      window.wx.error((res) => {
        console.log("微信功能异常", res);
      });
    })
    .catch((err) => {
      console.log("微信功能异常", err);
    });
}

export default {
  /**
   * 节流原理：在一定时间内，只能触发一次
   *
   * @param {Function} func 要执行的回调函数
   * @param {Number} wait 延时的时间
   * @param {Boolean} immediate 是否立即执行
   * @return null
   */

  throttle(func, wait, immediate) {
    if (immediate) {
      if (!flag) {
        flag = true;
        // 如果是立即执行，则在wait毫秒内开始时执行
        typeof func === "function" && func();
        timer = setTimeout(() => {
          flag = false;
        }, wait);
      }
    } else {
      if (!flag) {
        flag = true;
        // 如果是非立即执行，则在wait毫秒内的结束处执行
        timer = setTimeout(() => {
          flag = false;
          typeof func === "function" && func();
        }, wait);
      }
    }
  },
};
